
export const Boite = [
    {label: "Manuelle", value: 0,},
    {label: "Automatique", value: 1,},
]

export const Carburant = [
    {label: "Essence", value: 0,},
    {label: "Diesel", value: 1,},
    {label: "Electrique", value: 2,},
    {label: "Hybride", value: 3,},
]

export const FrequencyList = [
    {label: "Mensuelle", value: 0,},
    {label: "Annuelle", value: 1,},
]

export const Statut = [
    {label: "En commande", value: 0,},
    {label: "Affecté", value: 1,},
    {label: "Libre", value: 2,},
    {label: "Validation", value: 3,},
]

export const collaborateurType = [
    {label: "associé", value: 0,},
    {label: "cadre", value: 1,},
    {label: "employé", value: 2,},
]

export const Pneus = [
    {label: "Hiver", value: 0,},
    {label: "Eté", value: 1,},
]